/**
 * assetをロードするutil
 */

export const imagesLoad = (assets) => {
    const images = assets.map(imageSrc => {
        return new Promise((resolve) => {
        const img = new Image();
        img.src = imageSrc;
        img.onload = () => {
            resolve();
        };
        img.onerror = () => {
            resolve();
        };
        });
    });

    return Promise.all(images);
};